import { PHONE_NUMBER_RADIO } from "../templates/strings";

export const isNumeric = (value) => {
  return /^-?\d+$/.test(value);
};

export const normalizeNumber = (numberStr) => {
  if (numberStr.startsWith("+0")) {
    return numberStr.replace("+", "");
  }
  if (numberStr.startsWith("+4949")) {
    return numberStr.replace("+49", "+");
  }
  return numberStr;
};

export const isValidPhoneNumber = (phoneNumber, verificationMode) => {
  let regex = "";
  let isValidNumber = false;
  switch (verificationMode) {
    case PHONE_NUMBER_RADIO.STANDARD:
      isValidNumber = true;
      break;
    case PHONE_NUMBER_RADIO.LIGHT:
      regex = /^\+\d{6,}$/;
      if (regex.test(phoneNumber)) {
        isValidNumber = true;
      }
      break;
    case PHONE_NUMBER_RADIO.VERIFY:
      regex = /^(?:\+([1-9]\d{0,2})|00([1-9]\d{0,2})|0)(\d{9,11})$/;
      if (regex.test(phoneNumber)) {
        isValidNumber = true;
      }
      break;
    default:
      break;
  }
  return isValidNumber;
};

/**
 * ISO codes offered in the phone field: the countries of the funnel's loaded
 * country option (cockpit-shared countryOptions: countries[].isoCode).
 * Without a loaded option, Germany is offered.
 */
export const getPhoneCountryCodes = (countryOption) =>
  countryOption
    ? countryOption.countries.map((country) => country.isoCode)
    : ["DE"];

/**
 * Allowed postal code lengths of the funnel's countries, e.g. [5] for Germany,
 * [4, 5] for a combination (countries[].postalCodeLengths of the country option).
 * Without a loaded option, 4 or 5 digits are accepted so nobody gets blocked.
 */
export const getPostalCodeLengths = (countryOption) => {
  const lengths = countryOption
    ? countryOption.countries.flatMap((country) => country.postalCodeLengths)
    : [];
  return lengths.length ? [...new Set(lengths)].sort((a, b) => a - b) : [4, 5];
};

export const isValidPostalCode = (value, lengths) =>
  /^\d+$/.test(value || "") && lengths.includes(value.length);

export const getPostalCodeHint = (lengths) =>
  `Bitte geben Sie eine gültige ${lengths.join("- oder ")}-stellige Postleitzahl ein.`;

export const redirect = ({ redirectUrl, redirectUrlParams }) => {
  const params = `email=${redirectUrlParams.email}&firstname=${redirectUrlParams.firstName}&lastname=${redirectUrlParams.lastName}&phone=${redirectUrlParams.phone}`;
  window.location.replace(`${redirectUrl}?${params}`);
};

export const blurOnScroll = (target) => target.blur();

export const removeWhiteSpaces = ({ string }) =>
  string.replace(/\s+/g, " ").trim();
